import { CHECK_PASSWORD_LINK } from "./constants";


export function checkPasswordLink(login,link) {
          return {
            type: CHECK_PASSWORD_LINK,
            payload: {login,link}
          };
        }